export default __webpack_public_path__ + "backgroundCloud.01a7366.png";